import React from 'react';
import { Helmet } from "react-helmet";
import Layout from '../../components/Layout';
import smoothScroll from '../../functions/smoothScroll';
import { gtmPush } from '../../functions/gtm';
import queryString from 'query-string';
import Button from '../../audi-ui-components/Button';
import {
    UI_AUDI_MIN,
    PATH_XTIME,
    PATH_LOCATEADEALER,
    APPLICATION_CONTAINER_ID,
    DEFAULT_THEME
} from '../../constants';

import VehicleSearchForm from './VehicleSearchForm';
import PurchaseForm from './PurchaseForm';

import "./buy-service-plan.scss";

const FORM_MAINTENANCE = false;

const contact = (
    <aside className="contact-section">
        <p>
            Service Team: <a href="tel:1300734567"><b>1300 734 567</b></a>
            <br />Opening Hours: <b>Mon-Fri (9am-5pm)</b>
        </p>
    </aside>
);

class BuyServicePlan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            purchaseResult: null,
            searchResult: null,
            vehicle: null
            // searchResult: {plans: {"FDSPY5": {serviceDetails: []}, "FDSPTOPUP2": {serviceDetails: []}}},
            // vehicle: {vin: "WAUZZZGA7JA026894", mileage: 5000}
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            if (window.Stripe) {
                window.Stripe.setPublishableKey(process.env.RAZZLE_STRIPE_KEY_SP);
            } else {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = "https://js.stripe.com/v2/";
                script.onload = function () {
                    window.Stripe.setPublishableKey(process.env.RAZZLE_STRIPE_KEY_SP);
                };
                document.getElementsByTagName("head")[0].appendChild(script);
            }
        }
        gtmPush("buyServicePlan", "BspLoaded", "BspStart");
    }

    setSearchResult = (r, v) => {
        this.setState({searchResult: r, vehicle: v});
        smoothScroll.scrollTo(APPLICATION_CONTAINER_ID);
    }

    setPurchaseResult = (r) => {
        this.setState({purchaseResult: r});
        smoothScroll.scrollTo(APPLICATION_CONTAINER_ID);
    }

    render() {
        const {searchResult, purchaseResult} = this.state;
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        return (
            <Layout ui={query.ui || UI_AUDI_MIN} theme={theme}>
                <Helmet>
                    <title>Purchase a service plan | Audi Australia</title>
                </Helmet>

                <div className="audi-forms__hero">
                <div className="buy-service-plan__hero" style={{backgroundImage: `url('${process.env.PUBLIC_PATH}img/Audi_After-Sales_1200.jpg')`}}>
                    <div className="overlay">
                        <div className="content py-3 py-small-5">
                            <h1 className="aui-headline-3">Purchase a service plan</h1>
                        </div>
                    </div>
                </div>
                </div>

                <main className="audi-forms__page buy-service-plan pt-5">

                    {!searchResult && !purchaseResult && !FORM_MAINTENANCE &&
                        <VehicleSearchForm
                            vin={query.vin}
                            setSearchResult={this.setSearchResult}
                            contact={contact}
                            theme={theme}
                            onClickBookService={() => { gtmPush("buyServicePlan", "BspBookAService", "BspChoose"); this.props.history.push(PATH_XTIME); }}
                            onClickLocateDealer={() => { this.props.history.push(PATH_LOCATEADEALER); }}
                        />
                    }

                    {searchResult && !purchaseResult &&
                        <PurchaseForm
                            vehicle={this.state.vehicle}
                            availablePlans={searchResult.plans}
                            model={searchResult.model}
                            onSubmitSuccess={this.setPurchaseResult}
                            query={query}
                            theme={theme}
                        />
                    }

                    {purchaseResult && <div className="row mb-5">
                        <div className="col-small-1"></div>
                        <div className="col-small-5 col-large-6">
                            <p className="aui-headline-4 mb-3">Thank you. Your order has been confirmed.</p>
                            <p className="mb-3"><b>Order number: {purchaseResult}</b></p>
                            <p className="mb-5">You will receive two email confirmations for your order shortly, one containing your invoice and the second with your service plan certificate.</p>
                            <p className="mb-5">
                                <Button label="Book a service" buttonType="primary" theme={theme === "dark" ? "light" : null} onClick={() => { gtmPush("buyServicePlan", "BspBookAService", "BspThanks"); this.props.history.push(PATH_XTIME); }} />
                            </p>
                        </div>
                        <div className="col-small-1"></div>
                        <div className="col-small-4 col-large-3">
                            {contact}
                        </div>
                    </div>}

                    {FORM_MAINTENANCE && <div className="row mb-5">
                        <div className="col-small-1"></div>
                        <div className="col-small-5 col-large-6">
                            <p className="aui-headline-4 mb-3">This page is currently undergoing maintenance.</p>
                            <p className="mb-3">Please check back later.</p>
                        </div>
                        <div className="col-small-1"></div>
                        <div className="col-small-4 col-large-3">
                            {contact}
                        </div>
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default BuyServicePlan;
